import store from './store';

export const selectReports = store.get('reports');
